import _ from 'lodash'
import * as actions from './actions'
import mutations from './mutations'
import * as types from './mutation-types'

/* eslint-disable no-undef */
export default {
  namespaced: true,

  state: {
    /**
     * Корзина
     */
    cart: [],

    /**
     * Заказ
     */
    order: {},

    loading: {
      [types.PUT_TO_CART]: false,
      [types.REMOVE_FROM_CART]: false,
      [types.CREATE_ORDER]: false
    },

    success: {
      [types.PUT_TO_CART]: false,
      [types.REMOVE_FROM_CART]: false,
      [types.CREATE_ORDER]: false
    },

    errors: {
      [types.PUT_TO_CART]: [],
      [types.REMOVE_FROM_CART]: [],
      [types.CREATE_ORDER]: []
    }
  },

  mutations,
  actions,

  getters: {
    totalCount: (state, getters) => _.sum(_.map(state.cart, (item) => item.quantity)),

    totalPrice: (state, getters) => _.sum(_.map(state.cart, (item) => item.quantity * item.price))
  }
}



// WEBPACK FOOTER //
// ./dev-packages/Shop/assets/site/store/index.js